import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Login from './components/Login';
import AddParagraph from './components/AddParagraph';
import Dashboard from './components/Dashboard';
import Student from './components/Student';
import Users from './components/Users';
import Masters from './components/Masters';
import View from './components/View';
import Questions from './components/Questions';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './components/HomePage';
import LandingPage from './components/LandingPage';
import Contact from './components/Contact';
import ContactPage from './components/ContactPage';
import KnowTheProcess from './components/KnowTheProcess';
import Measure from './components/Measure';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import About from './components/About';
import Reports from './components/Reports';

function App() {
  return (
    <div>
    
      <Router>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/contact-us' element={<ContactPage />} />
          <Route path='/know-the-process' element={<KnowTheProcess />} />
          <Route path='/measure' element={<Measure />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/about-us' element={<About />} />
          <Route path='/login' element={<Login />} />
          <Route element={<ProtectedRoute />}>
          <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/students' element={<Student />} />
            <Route path='/add-paragraph' element={<AddParagraph />} />
            <Route path='/questions' element={<Questions />} />
            <Route path='/view' element={<View />} />
            <Route path='/master' element={<Masters />} />
            <Route path='/reports' element={<Reports />} />
            <Route path='/users' element={<Users />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}
export default App;
